/* eslint-disable import/prefer-default-export */
import moment from 'moment';

export const DEF_SEARCH_PARAM = {
  vehicleIds: [],
  fromTsInIST: moment(new Date()).startOf('day').format('YYYY-MM-DD HH:mm:ss'),
  toTsInIST: moment(new Date()).endOf('day').format('YYYY-MM-DD HH:mm:ss'),
  groupNames: [],
};

export const liveTblHeadName = [
  { name: 'Trip ID', id: 'tripId', sort: true },
  { name: 'From', id: 'fromCity' },
  { name: 'To', id: 'toCity' },
  {
    name: 'Scheduled Start Date',
    id: 'scheduledStartDate',
    unitConversion: '(DD-MM-YYYY HH:MM:SS)',
    sort: true,
  },
  {
    name: 'Scheduled End Date',
    id: 'scheduledEndDate',
    unitConversion: '(DD-MM-YYYY HH:MM:SS)',
    sort: true,
  },
  { name: 'Truck', id: 'truck', sort: true },
  { name: 'Driver', id: 'driver' },
  {
    name: 'Distance Travelled',
    id: 'distanceTravelledInkms',
    unitConversion: '(km)',
    sort: true,
  },
  {
    name: 'Mileage',
    id: 'mileage',
    unitConversion: '(kmpl)',
    sort: true,
  },
  {
    name: 'Fuel Consumed',
    id: 'fuelConsumedInLtrs',
    unitConversion: '(ltrs)',
    sort: true,
  },
  {
    name: 'Adblue Consumed',
    id: 'adblueConsumedInLtrs',
    unitConversion: '(ltrs)',
    sort: true,
  },
  {
    name: 'Avg Speed',
    id: 'avgSpeedInkmph',
    unitConversion: '(kmph)',
    sort: true,
  },
  { name: 'Trip Status', id: 'status', chip: true },
  {
    name: 'ETA',
    id: 'eta',
    unitConversion: '(DD:HH:MM:SS)',
    sort: true,
  },
  { name: 'Trip Share', id: 'share' },
  { name: 'Trip Track', id: 'liveLinkUrl' },
];

export const scheduledTblHeadName = [
  { name: 'Trip ID', id: 'tripId', sort: true },
  { name: 'From', id: 'fromCity' },
  { name: 'To', id: 'toCity' },
  {
    name: 'Scheduled Start Date',
    id: 'scheduledStartDate',
    unitConversion: '(DD-MM-YYYY HH:MM:SS)',
    sort: true,
  },
  {
    name: 'Scheduled End Date',
    id: 'scheduledEndDate',
    unitConversion: '(DD-MM-YYYY HH:MM:SS)',
    sort: true,
  },
  { name: 'Truck', id: 'truck', sort: true },
  { name: 'Driver', id: 'driver' },
  { name: 'Road Type', id: 'roadType' },
  { name: 'Planned Stops', id: 'plannedStops', sort: true },
  { name: 'Load Weight', id: 'load', sort: true },
  { name: 'Load Type', id: 'loadType' },
];

export const completedTblHeadName = [
  { name: 'Trip ID', id: 'tripId', sort: true },
  { name: 'From', id: 'fromCity' },
  { name: 'To', id: 'toCity' },
  {
    name: 'Scheduled Start Date',
    id: 'scheduledStartDate',
    unitConversion: '(DD-MM-YYYY HH:MM:SS)',
    sort: true,
  },
  {
    name: 'Scheduled End Date',
    id: 'scheduledEndDate',
    unitConversion: '(DD-MM-YYYY HH:MM:SS)',
    sort: true,
  },
  {
    name: 'Actual End Date',
    id: 'actualEndDate',
    unitConversion: '(DD-MM-YYYY HH:MM:SS)',
    sort: true,
  },
  { name: 'Truck', id: 'truck', sort: true },
  { name: 'Driver', id: 'driver' },
  {
    name: 'Distance Travelled',
    id: 'distanceTravelledInkms',
    unitConversion: '(kms)',
    sort: true,
  },
  {
    name: 'Mileage',
    id: 'mileage',
    unitConversion: '(kmpl)',
    sort: true,
  },
  {
    name: 'Fuel Consumed',
    id: 'fuelConsumedInLtrs',
    unitConversion: '(ltrs)',
    sort: true,
  },
  {
    name: 'Adblue Consumed',
    id: 'adblueConsumedInLtrs',
    unitConversion: '(ltrs)',
    sort: true,
  },
  {
    name: 'Avg Speed',
    id: 'avgSpeedInkmph',
    unitConversion: '(kmph)',
    sort: true,
  },
  { name: 'Score', id: 'score' },
  { name: 'Playback', id: 'playback' },
  { name: 'Trip Status', id: 'status', chip: true },
  { name: 'End Reason', id: 'tripEndType' },
  {
    name: 'Fuel lost in Idling',
    id: 'idlingFuelConsumed',
    unitConversion: '(ltrs)',
  },
  { name: 'Potential Savings', id: 'potentialSaving', unitConversion: '(INR)' },
];

export const applications = [
  { id: 1, name: 'Cement' },
  { id: 2, name: 'ECommerce' },
  { id: 3, name: 'Mining' },
  { id: 4, name: 'Agricultural produce' },
  { id: 5, name: 'Auto Carriers' },
  { id: 6, name: 'Cement Transportation' },
  { id: 7, name: 'Cold Chain - Dairy, meat and pharma' },
  { id: 8, name: 'Construction' },
  { id: 9, name: 'Fish' },
  { id: 10, name: 'Liquid/Gas transport' },
  { id: 11, name: 'Market load' },
  { id: 12, name: 'Milk' },
  { id: 13, name: 'Ores & Minerals Mining' },
  { id: 14, name: 'Parcel/FMCG/FMCD' },
  { id: 15, name: 'Port Movement' },
  { id: 16, name: 'Poultry' },
  { id: 17, name: 'Steel/Industrial goods/Auto Ancillaries' },
  { id: 18, name: 'Textile Transportation' },
  { id: 19, name: 'Waste Management' },
];

export const roadType = [
  { id: 1, name: 'Highway' },
  { id: 2, name: 'Intracity' },
  { id: 3, name: 'Others' },
  { id: 4, name: 'Intercity' },
];

export const loadType = [
  { id: 1, name: 'Full Load' },
  { id: 2, name: 'Partial Load' },
  { id: 3, name: 'Empty' },
];

export const reportNames = [
  {
    id: 1,
    name: 'Live',
  },
  {
    id: 2,
    name: 'Scheduled',
  },
  {
    id: 3,
    name: 'Completed',
  },
];
